module.exports = __webpack_public_path__ + "static/media/toggle.e8f7c8b5.svg";